export const PRICE = 'price';
export const PREVIOUS_PRICE = 'previous-price';
